// @flow

import * as React from 'react';
import pluralize from 'pluralize';
import styled from '@emotion/styled';
import { margin } from 'polished';

type Props = {
  count: number,
  maxEntriesPerPerson: number
};

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.primary,
  color: theme.color.white,
  borderRadius: 20,
  fontSize: theme.fontSize.tiny,
  textTransform: 'uppercase',
  textAlign: 'center',
  padding: '0.5em',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  ...margin(null, '0.25em'),
  outline: 0
}));

function EntryPill({ count, maxEntriesPerPerson }: Props) {
  if (count === 0) return null;
  return (
    <Wrapper>
      {maxEntriesPerPerson === 1 ? (
        <span>Entered</span>
      ) : (
        <span>
          {count} {pluralize('entry', count)}
        </span>
      )}
    </Wrapper>
  );
}

export default EntryPill;
